export * from './StrapiDoublePaneWidget'
